module.exports = __webpack_public_path__ + "img/icon_1223.08a1b3c6.svg";